import { useEffect } from "react";

import { getAuthToken } from "../../lib/api/tokenStore";
import { useGetUnreadCountQuery } from "./notificationsApi";

export const useUnreadNotifications = () => {
  const authenticated = Boolean(getAuthToken());

  const { data, refetch } = useGetUnreadCountQuery(undefined, {
    skip: !authenticated,
  });

  useEffect(() => {
    if (!authenticated) return undefined;

    const onFocus = () => refetch();
    const onVisible = () => {
      if (document.visibilityState === "visible") refetch();
    };

    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [authenticated, refetch]);

  const count = authenticated ? data ?? 0 : 0;

  return {
    count,
    label: count > 99 ? "99+" : String(count),
    hasUnread: count > 0,
    refetch,
  };
};

export default useUnreadNotifications;
